module.exports = __webpack_public_path__ + "static/img/icons8-data_recovery.e94a6e54.svg";